import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const ErrorMessage = styled.div`
    display: block;
    box-sizing: border-box;
    margin-bottom: ${props => props.theme.spacing.large};
    padding: ${props => props.theme.spacing.large};
    background: #f8d7d9;
    border: 1px solid #b70007;
    border-radius: 4px;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
    line-height: ${props => props.theme.lineHeight.normal};
    color: ${props => props.theme.colours.textDark};
    text-align: center;

    max-width: 343px;

    @media (max-width: 320px) {
        min-width: auto;
        max-width: 98%;
    }
`;
